module.exports = __webpack_public_path__ + "media/images/plans/img_small-wedding-0e467c5a79ee7664a1b1f52eb0839e3c.jpg";